module.exports = __webpack_public_path__ + "img/rise.7376b4fd.svg";